import type { JSX } from "solid-js";
import Nav from "./Nav";
import Footer from "./Footer";

interface PublicLayoutProps {
  children: JSX.Element;
}

export default function PublicLayout(props: PublicLayoutProps) {
  return (
    <div class="flex min-h-screen flex-col bg-iron-0 text-ink font-mono text-[13px] leading-relaxed antialiased">
      <Nav />
      <main class="flex-1">
        {props.children}
      </main>
      <Footer />
    </div>
  );
}
